module.exports = __webpack_public_path__ + "static/media/heart_sprite_final.e6f2756a.png";